import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class TicketDataService {
  private ticketCache = new Map<string, any>();

  setTicket(id: string, data: any) {
    this.ticketCache.set(id, data);
  }

  getTicket(id: string) {
    return this.ticketCache.get(id);
  }

  clearCache() {
    this.ticketCache.clear();
  }
}
